// https://vuex.vuejs.org/en/actions.html

import NewApiService from "../../../utils/new.api.service";
import JwtService from "../../../utils/jwt.service";

export default {
  login(context, credentials) {
    return new Promise((resolve,reject) => {
      context.commit("set_loading", true);
      context.commit("clearMessage", true);
      console.log(NewApiService)
      NewApiService.get("sanctum/csrf-cookie").then(() => {
        NewApiService.post("client/auth/login", credentials)
          .then(({ data }) => {
            context.commit("set_auth", data.token);
            resolve(data);
          })
          .catch(({ response }) => {
            reject(response)
          })
          .finally(() => {
            context.commit("set_loading", false);
          });
      })
      
    });
  },
  logout(context) {
    context.commit("purge_auth");
  },
  register(context, credentials) {
    return new Promise(resolve => {
      NewApiService.post("v1/client/register", { user: credentials })
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit("set_error", response.data.errors);
        });
    });
  },
  validation(context, form){
    return new Promise(resolve => {
      NewApiService.post("v1/client/validation", form)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit("set_error", response.data.errors);
        });
    });
  },
  check_auth(context) {
    if (JwtService.getToken()) {
      NewApiService.setHeader();
      NewApiService.get("/client/auth/user").then(({ data }) => {
        context.commit("set_client", data.user);
        context.commit("set_address", data.address);
        context.commit("set_credit", data.credit);
        context.commit("set_price", data.price);
        if(data.openOrder){
          context.commit("scheduler/set_order", data.openOrder,{root:true})
          context.commit("scheduler/set_open_reservation", data.reservations,{root:true})
        }
        context.commit("set_open_order", data.openOrder);

      });
    } else {
      context.commit("purge_auth");
    }
  },
  updateProfile(context, {client, address}){
    return new Promise((resolve, reject) => {
      NewApiService.put("/client/auth/user", {client, address})
      .then(({data}) => {
        context.commit("set_client", data.client);
        context.commit("set_address", data.address);
        resolve(data)
      })
      .catch(({response}) => {
        reject(response.data)
      })
    })
  },
  forgot(context, {email}){
    return new Promise((resolve, reject) => {
      NewApiService.get("/client/auth/forgot-password", {email})
      .then(({data}) => {
        resolve(data)
      })
      .catch(({response}) => {
        reject(response)
      })
    })
  },
  resetPassword(context, {email, token, password, password_confirmation}){
    return new Promise((resolve, reject) => {
      NewApiService.post("/client/auth/reset-password", {email, token, password, password_confirmation})
      .then(({data}) => {
        resolve(data)
      })
      .catch(({response}) => {
        reject(response)
      })
    })
  }
};
